import { useCNDNStore } from '../../stores/CNDNStore';

type Props = {
    form: any
}

function Hook({ form }: Props) {

    const onClearHandler = () => {
        form.setFields([
            {
                name: 'subClientId',
                value: '',
                errors: []
            },
            {
                name: 'dateRange',
                value: '',
                errors: []
            },
            {
                name: 'oracleInvoiceNumber',
                value: '',
                errors: []
            }
        ]);
        useCNDNStore.setState({ search: [] });
    }
    return { onClearHandler }
}

export default Hook